var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"editable"},[_vm._v(_vm._s(_vm.textToRender))])
}
var staticRenderFns = []

export { render, staticRenderFns }